import { render, staticRenderFns } from "./IconBackArrow.vue?vue&type=template&id=6850120c&"
import script from "./IconBackArrow.vue?vue&type=script&lang=js&"
export * from "./IconBackArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6850120c')) {
      api.createRecord('6850120c', component.options)
    } else {
      api.reload('6850120c', component.options)
    }
    module.hot.accept("./IconBackArrow.vue?vue&type=template&id=6850120c&", function () {
      api.rerender('6850120c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconBackArrow.vue"
export default component.exports